const APIS = {
  ORDER: "/logisticservice/api/order/",
  CURRENT_MERCHANT: "/logisticservice/api/merchant/current-merchant-profile/",
  REMARK: "/logisticservice/api/remark/",
  BRANCH: "/logisticservice/api/branch/",
  COMMENT: "/commentservice/api/comment/",
  LOCATION: "/logisticservice/api/location/",
  FLAT_LOCATION: "/logisticservice/api/location/flat-location/",
  DESTINATION: "/logisticservice/api/location/list/",
  STATUS: "/logisticservice/api/status/",
  INVOICE: "/invoiceservice/api/merchant-invoice/invoice-id/",
  ORDER_HISTORY: "/historyservice/api/history/",
  CUSTOMER: "/logisticservice/api/customer/",
  RECEIVER_DETAIL: "/logisticservice/api/receiver-detail/",
  SERVICE_TYPE: "/logisticservice/api/service-type/",
  PRODUCT_TYPE: "/logisticservice/api/product-type/",
  REFERENCE_TYPE: "/logisticservice/api/reference-type/",
  SUB_ORDER: "/logisticservice/api/sub-order/",
  DRAFT_ORDER: "/pickuprequestservice/api/order/draft-orders/",
  USER: "/usermanagementservice/api/user/",
  RUNSHEET: "/runsheetservice/api/runsheet/order-runsheet/",
  RTV: "/rtvorderservice/api/rtv-order/order-rtv/",
  PICKUPREQUEST: "/pickuprequestservice/api/pickup-request/",
  PERMISSION: "/permission/",
};

export default APIS;
